package com.bikompanion.ui.home

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import com.bikompanion.domain.BikeRatingRepository
import kotlin.time.Duration.Companion.minutes
import kotlin.time.Duration.Companion.seconds

internal class PendingVoteRecovery(
    private val scope: CoroutineScope,
    private val ratingRepository: BikeRatingRepository,
) {
    private var job: Job? = null

    fun start() {
        if (job?.isActive == true) return
        job = scope.launch {
            var delayIndex = 0
            while (true) {
                val result = ratingRepository.flushPendingVotes()
                if (!result.hasPendingVotes) return@launch
                delay(RetryDelays[delayIndex])
                delayIndex = (delayIndex + 1).coerceAtMost(RetryDelays.lastIndex)
            }
        }
    }

    fun stop() {
        job?.cancel()
        job = null
    }
}

private val RetryDelays = listOf(30.seconds, 1.minutes, 5.minutes)
